var map = {
	"./absence.png": "231e",
	"./bebidas.png": "6d7c",
	"./blusas.png": "3b31",
	"./bolsas.png": "4388",
	"./brinquedos.png": "503f",
	"./calcados.png": "56f1",
	"./calcas.png": "0487",
	"./diversos.png": "785e",
	"./joias.png": "56a5",
	"./livros.png": "58ca",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./maquiagens.png": "00bb",
	"./perfumes.png": "2f3e",
	"./pix.png": "d192",
	"./thankyou.gif": "a929",
	"./vestidos.png": "a8ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";